import { PopupManager } from 'managers/PopupManager'
import { signal } from 'services/SignalsService'
import { StoreageService } from 'services/StoreageService'
import { debug } from 'settings/custom/build'
import { backEndVersion } from 'settings/custom/general'
import { log } from 'utils/Logger'

const method = 'POST'

const errorAllowRetryByUserCodes = [
  'error.integration.unknownError',
  'error.integration.internalError',
  'error.integration.timeout',
]

const paths = {
  init: '/v1/client/init',
  spin: '/v1/client/spin',
  history: '/v1/client/transactions',
  error: '/v1/client/error',
}

const pathsV2 = {
  init: '/init',
  spin: '/spin',
  round: '/round',
  history: '/transactions',
  error: '/error',
}
const maxAttempts = 1

let respounceInProgress = false

function makeFetch(headers, body, path) {
  const response = new Promise((res, rej) => {
    fetch(game.models.GameModel.URL + path, {
      method,
      headers,
      body,
    })
      .then((result) => res(result))
      .catch((err) => rej(err))
  })
  return response
}

async function tryFetch(header, body, path) {
  respounceInProgress = true
  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    try {
      const response = await timeoutPromise(
        makeFetch(header, body, path),
        attempt,
      )
      const data = await response.json()
      log(data)

      if (!game.models.GameModel.blockGameOnError) {
        if (errorAllowRetryByUserCodes.includes(data.code)) {
          game.models.GameModel.requestAgainAllowed = true
          game.models.GameModel.isFinishedContext = data.isFinishedContext
          game.models.GameModel.showBonusPopupContinue = true

          if (game.models.GameModel.isFinishedContext === false) {
            game.models.GameModel.requestAgainAllowed = false
            game.models.GameModel.showBonusPopupContinue = false
            signal.dispatch('STATE:MACHINE:STOP')
          }

          PopupManager.show(data.code)
          return data
        }
        else {
          game.models.GameModel.requestAgainAllowed = false
          game.models.GameModel.isFinishedContext = true
          game.models.GameModel.showBonusPopupContinue = false
        }
      }

      if (data.status && data.status.code === 200) {
        respounceInProgress = false
        return data
      }
      else if (data.status && data.status.code === 400) {
        if (data.code === 'error.restricted-country') {
          signal.dispatch('STATE:MACHINE:STOP')
          PopupManager.show(data.code)
          StoreageService.set('error', null)
          respounceInProgress = false

          return data
        }

        if (data) {
          signal.dispatch('STATE:MACHINE:STOP')
          PopupManager.show(data.code)
          StoreageService.set('error', null)
          return data
        }
      }
      else {
        signal.dispatch('STATE:MACHINE:STOP')
        PopupManager.show('serverError')
        return data ? data : {}
      }
    }
    catch (error) {
      log(error)
    }
  }
}

function makeRequest(type) {
  return function (params) {
    const body = JSON.stringify(params)
    const path = backEndVersion === 2 ? pathsV2 : paths
    const pagination = StoreageService.get('error')
    const headers = new Headers()
    headers.set('Content-Type', 'application/json')
    if (pagination != null && !debug) {
      headers.set('error', JSON.stringify(pagination))
      StoreageService.set('error', null)
    }

    return tryFetch(headers, body, path[type])
  }
}

export const makeInitRequest = makeRequest('init')
export const makeSpinRequest = makeRequest('spin')
export const makeRoundRequest = makeRequest('round')
export const makeHistoryRequest = makeRequest('history')

// function asyncTimer(duration) {
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       resolve('Timer finished')
//     }, duration)
//   })
// }

function timeoutPromise(promise, attempt) {
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      PopupManager.show('serverError')
    }, 60000)

    window.addEventListener('offline', () => {
      if (respounceInProgress) {
        signal.dispatch('STATE:MACHINE:STOP')
        PopupManager.show('internetConnection')

        clearTimeout(timeoutId)
      }
    })

    promise.then(
      (result) => {
        clearTimeout(timeoutId)
        resolve(result)
      },
      (error) => {
        if (attempt >= maxAttempts - 1) {
          PopupManager.show('serverError')
          clearTimeout(timeoutId)
          reject(error)
        }
      },
    )
  })
}

//---------------------------------------------------------------------

if (debug) {
  window.error = function (status) {
    const valid = [
      400,
      401,
      402,
      403,
      404,
      405,
      410,
      411,
      412,
      413,
      414,
      419,
      420,
      421,
      422,
      423,
      424,
      425,
      426,
      429,
    ]
    if (!valid.includes(status)) {
      return `${status} is not valid`
    }

    makeRequest('error')({ status })

    return `${status} sent`
  }
}
